import Apple from "./Img/Apple.jpg";
import Labador from "./Img/BlackLabrador.png";
import Rock from "./Img/BlackRock.jpg";
import Blend from "./Img/Blend.jpg";
import CaveBoredApe from "./Img/CaveBoredApe.png";
import TwochainzApe from "./Img/ChainzBoredApe.png";
import Bust from "./Img/DigitalBust.jpg";
import Frank from "./Img/FrankOcean.png";
import Hidden from "./Img/Hidden.jpg";
import HumanGrid from "./Img/HumanGrid.jpg";
import Ja from "./Img/JaMorant.jpg";
import Jcole from "./Img/JCole.jpg";
import Lefou from "./Img/Lefou.jpg";
import Mark from "./Img/MarkRuffalo.jpg";
import Paraphase from "./Img/PARAPHASE.jpg";

const icons = [
  {
    id: 1,
    s: 0.7,
    x: 200,
    y: 45,
    image: Labador,
    title: "Labador",
  },

  {
    id: 2,
    s: 0.8,
    x: 82,
    y: 72,
    image: Paraphase,
    title: "Paraphase",
  },
  {
    id: 3,
    s: 0.8,
    x: 265,
    y: 410,
    image: Lefou,
    title: "Lefou",
  },
  {
    id: 4,
    s: 0.8,
    x: 720,
    y: 364,
    image: Blend,
    title: "Blend",
  },

  {
    id: 5,
    s: 0.7,
    x: 216,
    y: 316,
    image: CaveBoredApe,
    title: "Cave Bored Ape",
  },
  {
    id: 6,
    s: 0.7,
    x: 535,
    y: 430,
    image: Apple,
    title: "Apple",
  },
  {
    id: 7,
    s: 0.75,
    x: 274,
    y: 203,
    image: Rock,
    title: "Rock",
  },

  {
    id: 8,
    s: 0.8,
    x: 133,
    y: 193,
    image: TwochainzApe,
    title: "2Chainz Ape",
  },
  {
    id: 9,
    s: 0.8,
    x: 700,
    y: 88,
    image: Ja,
    title: "Ja Morant",
  },
  {
    id: 10,
    s: 0.8,
    x: 633,
    y: 290,
    image: Bust,
    title: "Human Bust",
  },

  {
    id: 11,
    s: 0.8,
    x: 129,
    y: 357,
    image: HumanGrid,
    title: "Human Grid",
  },

  {
    id: 12,
    s: 0.8,
    x: 510,
    y: 230,
    image: Jcole,
    title: "J Cole",
  },
  {
    id: 13,
    s: 0.8,
    x: 396,
    y: 72,
    image: Hidden,
    title: "Hidden",
  },

  {
    id: 14,
    s: 0.8,
    x: 543,
    y: 60,
    image: Frank,
    title: "Frank Ocean",
  },

  {
    id: 15,
    s: 0.8,
    x: 413,
    y: 334,
    image: Mark,
    title: "Mark Ruffalo",
  },
];

export default icons;
